import PropertyService from "./propertyService.js";
import {GoogleMap} from "./googleMap.js";

const handleSelectNavigation = (selector, baseUrl, callback) => {
    const selectElement = document.querySelector(selector);
    if (!selectElement) return;

    selectElement.addEventListener("change", (e) => {
        const value = e.target.value;
        window.location.href = `${baseUrl}${value}`;
        callback && callback(value);
    });
};

// 選択されたoptionのテキストを取得して表示する関数
const updateTypeText = (selectElement) => {
    const typeTextElement = document.querySelector(".js-search-map__type-text");
    if (!typeTextElement || !selectElement) return;

    const selectedOption = selectElement.options[selectElement.selectedIndex];
    typeTextElement.textContent = selectedOption.textContent;
};

const main = () => {
    if (!document.querySelector(".js-search-map")) return;

    const toggleButton = document.querySelector(
        ".js-search-map__toggle-button"
    );
    const menu = document.querySelector(".js-search-map__menu");

    toggleButton.addEventListener("click", () => {
        const isOpen = toggleButton.getAttribute("data-open") === "true";
        toggleButton.setAttribute("data-open", !isOpen);
        menu.toggleAttribute("data-active");
    });

    window.addEventListener("marker:click", (e) => {
        toggleButton.setAttribute("data-open", true);
        menu.setAttribute("data-active", "");
    });

    window.addEventListener("cluster:click", (e) => {
        toggleButton.setAttribute("data-open", true);
        menu.setAttribute("data-active", "");
    });

    const googleMap = new GoogleMap({
        api_key: document
            .querySelector('meta[name="google-api-key"]')
            .getAttribute("content"),
        map_id: document
            .querySelector('meta[name="google-map-id"]')
            .getAttribute("content"),
    });

    // URLのフラグメント（#以降）を取得
    const fragment = window.location.hash.substring(1); // '#'を除去
    const selectElement = document.querySelector(".js-search-map__select select");

    // 初期値の設定
    if (fragment) {
        selectElement.value = fragment;
        console.log(`Selected: ${fragment}`);
    } else {
        selectElement.value = "house"; // デフォルト値
    }

    // 初期表示時にもテキストを更新
    updateTypeText(selectElement);

    handleSelectNavigation(".js-search-map__select select", "#", async (value) => {
        if (!googleMap.map || !googleMap.markerManager) return;

        // テキストを更新
        updateTypeText(selectElement);

        const bounds = googleMap.map.getBounds();
        if (!bounds) return;

        const northEast = bounds.getNorthEast();
        const southWest = bounds.getSouthWest();
        const type = window.location.hash.slice(1) || "all";
        document
            .querySelector(".js-search-map__loading")
            .removeAttribute("data-hidden");

        // 選択されたタイプに基づいて物件データを取得
        const data = await PropertyService.fetchPropertiesInBounds(
            type,
            southWest.lat(),
            northEast.lat(),
            southWest.lng(),
            northEast.lng()
        );

        // マーカーとクラスターを更新
        await googleMap.markerManager.updateMarkers(data);
        document
            .querySelector(".js-search-map__loading")
            .setAttribute("data-hidden", "");
    });
};

export default main;
